import { gsap } from 'gsap';
import React, { useEffect, useRef, useState } from 'react';
import { bigNumberToLetterFormatter } from 'scripts/utils/bigNumberToLetterFormatter';
import { inFrames } from 'scripts/utils/inFrames';
import { numberWithCommas } from 'scripts/utils/numberWithCommas';
import { Easings } from 'scripts/utils/tweenHelpers';

type Props = {
    num: number,
    format?: 'comma' | 'letter',
};

export const CountedNumber = React.memo(({ num, format = 'comma' }: Props) => {
    const valueRef = useRef<number>();
    const [value, setValue] = useState<number>(num);

    useEffect(() => {
        if (value === num) {
            return;
        }

        gsap.fromTo(valueRef, { current: Math.round(value) }, {
            current: Math.round(num),
            onUpdate: () => setValue(Math.round(valueRef.current)),
            duration: inFrames(50),
            ease: Easings.chartOpacity,
        });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [num]);
    return format === 'comma'
        ? <>{numberWithCommas(value)}</>
        : <>{bigNumberToLetterFormatter(value, 1)}</>;
});
